/**
 * Copyright (c) Mayoral Moda Infantil, S.A.U. and affiliates.
 */

export { default as BrandLogo } from './BrandLogo';
export { default as Brand } from './Brand';
